// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.AddToJobFolderModal-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.AddToJobFolderModal-wrapper .titleSection {
  padding: 32px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.AddToJobFolderModal-wrapper .titleSection h2 {
  font-size: 24px;
  font-weight: 600;
  color: var(--color_neutral_900);
}
.AddToJobFolderModal-wrapper .buttonsSection {
  padding: 32px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.AddToJobFolderModal-wrapper .actionsButtons {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
}
.AddToJobFolderModal-wrapper .jobsList {
  overflow-y: auto;
  flex: 1 1;
  position: relative;
}
.AddToJobFolderModal-wrapper .jobsList::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.AddToJobFolderModal-wrapper .jobsList::-webkit-scrollbar-track {
  background: transparent;
}
.AddToJobFolderModal-wrapper .jobsList::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.AddToJobFolderModal-wrapper .jobsList:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.AddToJobFolderModal-wrapper .jobsList::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.AddToJobFolderModal-wrapper .jobsList .test {
  width: 100%;
  background-color: aqua;
}
.AddToJobFolderModal-wrapper .jobsList:after {
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);
  content: "";
  height: 20px;
  left: 0;
  bottom: 99px;
  position: fixed;
  width: 100%;
}
.AddToJobFolderModal-wrapper .sectionWrapper + .sectionWrapper {
  margin-top: 24px;
}
.AddToJobFolderModal-wrapper .sectionTitle {
  font-size: 12px;
  font-weight: 400;
  color: #9BA1AD;
  color: var(--color_neutral_500, #9BA1AD);
  padding: 0 32px;
}
.AddToJobFolderModal-wrapper .emptySection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 32px;
  text-align: center;
}

.AddToJobFolderModal-loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.highlightText {
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/AddToJobFolderModal/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAeF;AAbE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAeJ;AAbI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AAeN;AAXE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAaJ;AAVE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAYJ;AATE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;AAWJ;ADnCE;EACE,UAAA;EACA,WAAA;ACqCJ;ADlCE;EACE,uBAAA;ACoCJ;ADjCE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACmCJ;AD/BI;EACE,oCApBS;ACqDf;AD7BE;EACE,oCAxBY;ACuDhB;AAzBI;EACE,WAAA;EACA,sBAAA;AA2BN;AAvBE;EACE,sEAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAyBJ;AAtBE;EACE,gBAAA;AAwBJ;AArBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,wCAAA;EACA,eAAA;AAuBJ;AApBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAqBJ;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAoBF;;AAjBA;EACE,+BAAA;AAoBF","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.AddToJobFolderModal-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n\n  .titleSection {\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    row-gap: 24px;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n      color: var(--color_neutral_900);\n    }\n  }\n\n  .buttonsSection {\n    padding: 32px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .actionsButtons {\n    display: flex;\n    flex-direction: row;\n    column-gap: 16px;\n  }\n\n  .jobsList {\n    overflow-y: auto;\n    flex: 1;\n    position: relative;\n\n    @include scrollbar;\n\n    .test {\n      width: 100%;\n      background-color: aqua;\n    }\n  }\n\n  .jobsList:after {\n    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);\n    content: \"\";\n    height: 20px;\n    left: 0;\n    bottom: 99px;\n    position: fixed;\n    width: 100%;\n  }\n\n  .sectionWrapper+.sectionWrapper {\n    margin-top: 24px;\n  }\n\n  .sectionTitle {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--color_neutral_500, #9BA1AD);\n    padding: 0 32px;\n  }\n\n  .emptySection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    width: 100%;\n    height: 100%;\n    padding: 0 32px;\n    text-align: center;\n  }\n}\n\n.AddToJobFolderModal-loading-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.highlightText {\n  color: var(--color_primary_500);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
